import { configureStore } from "@reduxjs/toolkit";

import appConfigStore from "./modules/AppConfig/index.store";
// eslint-disable-next-line import/no-cycle
import logisticsStore from "./modules/Logistics/index.store";
// eslint-disable-next-line import/no-cycle
import catalogStore from "./modules/Catalog/index.store";
// eslint-disable-next-line import/no-cycle
import ordersStore from "./modules/Orders/index.store";
// eslint-disable-next-line import/no-cycle
import dealerUsers from "./modules/DealerUsers/index.store";
// eslint-disable-next-line import/no-cycle
import reportStore from "./modules/Report/index.store";
// eslint-disable-next-line import/no-cycle
import checkoutStore from "./modules/Checkout/index.store";

const store = configureStore({
  reducer: {
    appConfig: appConfigStore,
    logistics: logisticsStore,
    orders: ordersStore,
    catalog: catalogStore,
    report: reportStore,
    dealerUsers,
    checkout: checkoutStore,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
